/**
 * 「いま発行」バッジ用: このブラウザセッションで発行した書類を案件ごとに記録する。
 * 発行→ダウンロード画面→見積書→発行… と連続で発行しても、
 * ダウンロード画面（CasePdfsPage）で直近に発行した全書類にバッジを付けられるよう、
 * 遷移 state ではなく sessionStorage に持つ（リロードにも耐える）。
 */
const WINDOW_MS = 30 * 60 * 1000; // 30分より前の発行は「いま」扱いしない

type Entry = { id: string; at: number };

const storageKey = (caseId: string) => `recent-issued:${caseId}`;

function read(caseId: string): Entry[] {
  try {
    const raw = sessionStorage.getItem(storageKey(caseId));
    const parsed = raw ? (JSON.parse(raw) as Entry[]) : [];
    const cutoff = Date.now() - WINDOW_MS;
    return parsed.filter((e) => e.at >= cutoff);
  } catch {
    return [];
  }
}

/** 発行成功時に呼ぶ */
export function markIssued(caseId: string, docId: string): void {
  try {
    const entries = read(caseId).filter((e) => e.id !== docId);
    entries.push({ id: docId, at: Date.now() });
    sessionStorage.setItem(storageKey(caseId), JSON.stringify(entries));
  } catch {
    // sessionStorage が使えない環境ではバッジなしで動作継続
  }
}

/** 直近30分以内にこのセッションで発行した書類ID（新しい順） */
export function getRecentIssuedIds(caseId: string): string[] {
  return read(caseId)
    .sort((a, b) => b.at - a.at)
    .map((e) => e.id);
}
